import { Metamodel } from '../base/model';
import { AdapterRegistry } from './adapter-registry';
import { NamedAdapter } from './named.adapter';
import { A365BackendModel as Model } from '../a365.backendmodel';
import { annotationsToTags, tagsToAnnotations } from '../../shared/utils/tags.util';
import { Tag } from '../tags/tags';
import { SqlDatabase } from '../sqlDatabase/sqlDatabase';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SqlDatabase),
    adapts: {
        name: '*',
        location: '*',
        kind: '*',
        properties: {
            description: '*',
            collation: '*',
            maxSizeBytes: '*',
            databaseGuid: '*',
            status: '*'
        }
    }
})
export class SqlDatabaseAdapter extends NamedAdapter<SqlDatabase, Model.SqlDatabase> {
    protected _toResource(sqlDatabase: SqlDatabase): Model.SqlDatabase {
        const sqlDatabaseResource = super._toResource(sqlDatabase) as Model.SqlDatabase;
        sqlDatabaseResource.location = sqlDatabase.location;
        sqlDatabaseResource.tags = sqlDatabase.rawTags;

        sqlDatabaseResource.properties = {
            collation: sqlDatabase.collation,
            maxSizeBytes: sqlDatabase.maxSizeBytes,
            databaseGuid: sqlDatabase.databaseGuid,
            status: sqlDatabase.sqlDatabaseStatus
        };

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const annotations: any[] = [];
        const tagAdapter = this.context.adapterFor(Tag.MODEL);
        tagsToAnnotations(annotations, sqlDatabase.tags, tagAdapter);
        tagsToAnnotations(annotations, sqlDatabase.malformedTags, tagAdapter);
        this.properties(sqlDatabaseResource).annotations = annotations;

        return sqlDatabaseResource;
    }

    protected _toModel(sqlDatabaseResource: Model.SqlDatabase, sqlDatabase?: SqlDatabase): SqlDatabase {
        if (!sqlDatabase) {
            sqlDatabase = SqlDatabase.MODEL.create<SqlDatabase>();
        }
        super._toModel(sqlDatabaseResource, sqlDatabase);

        const tagAdapter = this.context.adapterFor(Tag.MODEL);
        annotationsToTags(sqlDatabase.tags, sqlDatabase.malformedTags, sqlDatabaseResource.properties.annotations, tagAdapter);

        sqlDatabase.rawTags = sqlDatabaseResource.tags;
        sqlDatabase.location = sqlDatabaseResource.location;

        const properties = sqlDatabaseResource.properties;
        if (properties) {
            sqlDatabase.collation = properties.collation;
            sqlDatabase.maxSizeBytes = properties.maxSizeBytes;
            sqlDatabase.databaseGuid = properties.databaseGuid;
            sqlDatabase.sqlDatabaseStatus = properties.status;
        }

        return sqlDatabase;
    }
}
